<template>
  <div class="footer">
    <div class="foot flex_center">
      <!-- footer -->
      <!-- Copyright 2016 麻醉眼界
            <a href="http://beian.miit.gov.cn/" target="_blank">沪ICP备16022724号-1</a> -->

      <div class="top">
        <div class="left">
          <p class="wxgzh">微信公众号</p>
          <img class="ewm" src="https://anesthesiavision.oss-cn-shanghai.aliyuncs.com/headimage/erweima.jpg" alt="" />
        </div>
         <div class="left" style="margin-left: 55px;margin-top: -2px;">
          <p class="wxgzh">微信视频号</p>
          <img class="ewm" src="@/assets/img/shipin23.png" alt="" />
        </div>
        <div class="right">
          <p>联系电话 <span class="small_text">021-50832011</span></p>
          <p>商务合作 <span class="small_text">xuzhi@anesthesiavision.cn</span></p>
          <p>联系地址 <span class="small_text">上海市浦东新区锦绣路3891号锦绣中环·文创产业基地</span></p>
        </div>
      </div>
       <div class="bot"><a href="https://beian.miit.gov.cn/#/Integrated/recordQuery" target="_blank" >Copyright 2016 麻醉眼界沪ICP备16022724号-1</a></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "footer",
  data() {
    return {};
  },
  props: {},
  methods: {},
  mounted() {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.footer{
  height: 343px;
  width: 100%;
}
.foot {
  /* text-align: center; */
  /* height: 106px; */
  height: 343px;
  width: 100%;
  background: #2a2a2a;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 17px;
  color: #fff;
  font-weight: bold;
  position: relative;
}

.top {
  display: flex;
  align-items: center;
  /* margin-top: 20px; */
  padding-bottom: 10px;
}
.right {
  text-align: left;
  border-left: 1px solid #db414e;
  height: 123px;
  margin-left: 94px;
  padding-left: 57px;
  box-sizing: border-box;
    padding-top: 10px;
}
.right :nth-child(1),
:nth-child(2),
:nth-child(3) {
  margin-top: 6px;
}
.ewm {
  width: 125px;
  height: 125px;
}
.left {
  display: flex;
  flex-direction: column;
  position: relative;
}
.wxgzh {
  position: absolute;
  top: -42px;
}
.bot {
    letter-spacing: 1px;
    position: absolute;
    bottom: 0px;
    width: 100%;
    padding: 27px 0px;
    background-color: #1d1d1d;
    font-size: 13px;
}
.small_text{
    font-size: 13px;
}
</style>


// WEBPACK FOOTER //
// src/components/assembly/Footer.vue